/* ============================================================
   Полноэкранное мобильное меню: пункты с иконками и стаггер-
   анимацией, вход/регистрация, сегментный переключатель языка.
   ============================================================ */
import { useAppStore } from '../../store';
import { useFedStore, useL } from '../store';
import { Ic } from '../icons';

const ITEM_ICONS = {
  home: 'home', tournaments: 'trophy', news: 'news', live: 'play',
  winners: 'medal', projects: 'layers', about: 'info',
  partners: 'hand', gallery: 'image', regulations: 'doc', contacts: 'phone',
};

export default function FedMobileMenu() {
  const route = useAppStore((s) => s.route);
  const user = useAppStore((s) => s.user);
  const { menuOpen, go, toggleLang, lang } = useFedStore();
  const L = useL();

  if (!menuOpen) return null;

  const items = [
    ['home', L.nav_home], ['tournaments', L.nav_tournaments], ['news', L.nav_news], ['live', L.nav_live],
    ['winners', L.nav_winners], ['projects', L.nav_projects], ['about', L.nav_about],
    ['partners', L.nav_partners], ['gallery', L.nav_gallery], ['regulations', L.nav_regs], ['contacts', L.nav_contacts],
  ];

  return (
    <div
      id="fed-mobile-menu"
      className="fixed z-[190] flex flex-col overflow-y-auto"
      style={{
        inset: '72px 0 0', background: 'rgba(6,6,8,.98)',
        backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
        padding: '18px 16px 28px',
      }}
    >
      <div className="grid grid-cols-2 gap-2">
        {items.map(([key, label], i) => {
          const active = route === key;
          return (
            <button
              key={key}
              onClick={() => go(key)}
              className="fed-menu-item fed-press cursor-pointer rounded-[14px]"
              style={{
                animationDelay: `${i * 0.03}s`,
                display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 11,
                minHeight: 54, padding: '12px 13px', textAlign: 'left',
                background: active ? 'rgba(225,18,23,.12)' : 'var(--fed-surface)',
                border: `1px solid ${active ? 'var(--fed-line-accent)' : 'var(--fed-line)'}`,
              }}
            >
              <span
                className="flex-shrink-0 flex items-center justify-center rounded-[9px]"
                style={{
                  width: 32, height: 32,
                  background: active ? 'rgba(225,18,23,.16)' : 'var(--fed-surface-3)',
                  color: active ? 'var(--fed-accent-bright)' : 'var(--fed-fg-muted)',
                }}
              >
                <Ic name={ITEM_ICONS[key] || 'chevR'} size={16} sw={1.8} />
              </span>
              <span
                className="font-display font-semibold uppercase leading-[1.1] flex-1"
                style={{ fontSize: 13.5, letterSpacing: '.02em', color: active ? 'var(--fed-fg)' : 'var(--fed-fg-soft)' }}
              >
                {label}
              </span>
              {active && (
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--fed-accent-bright)', boxShadow: '0 0 8px var(--fed-accent-glow)', flexShrink: 0 }} />
              )}
            </button>
          );
        })}
      </div>

      {!user ? (
        <div className="fed-menu-item flex gap-2.5" style={{ marginTop: 16, animationDelay: '.32s' }}>
          <button
            onClick={() => go('auth', { authMode: 'login' })}
            className="fed-press flex-1 h-[50px] border border-line-2 bg-surface text-fg rounded-[13px] cursor-pointer font-display font-semibold uppercase"
            style={{ fontSize: 15 }}
          >
            {L.login}
          </button>
          <button
            onClick={() => go('auth', { authMode: 'signup' })}
            className="fed-press flex-1 h-[50px] border-none text-white rounded-[13px] cursor-pointer font-display font-bold uppercase"
            style={{ fontSize: 15, background: 'linear-gradient(120deg,var(--fed-accent-bright),var(--fed-accent-deep))', boxShadow: '0 12px 28px -12px var(--fed-accent-glow)' }}
          >
            {L.signup}
          </button>
        </div>
      ) : (
        <div className="fed-menu-item flex gap-2.5" style={{ marginTop: 16, animationDelay: '.32s' }}>
          <button
            onClick={() => go('profile')}
            className="fed-press flex-1 h-[50px] border border-line-2 bg-surface text-fg rounded-[13px] cursor-pointer font-display font-semibold uppercase"
            style={{ fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
          >
            <Ic name="user" size={16} color="var(--fed-accent-bright)" />
            <span className="truncate" style={{ maxWidth: 160 }}>{user.nickname || user.email}</span>
          </button>
          {(user.role === 'admin' || user.user_type === 'admin') && (
            <button
              onClick={() => go('admin')}
              className="fed-press h-[50px] px-5 border border-line-accent rounded-[13px] cursor-pointer font-display font-bold uppercase text-accent-bright"
              style={{ fontSize: 14, background: 'rgba(225,18,23,.08)' }}
            >
              Админ
            </button>
          )}
          {user.user_type === 'smm' && (
            <button
              onClick={() => go('smm')}
              className="fed-press h-[50px] px-5 border border-line-accent rounded-[13px] cursor-pointer font-display font-bold uppercase text-accent-bright"
              style={{ fontSize: 14, background: 'rgba(225,18,23,.08)' }}
            >
              SMM
            </button>
          )}
        </div>
      )}

      {/* язык: сегментный переключатель РУ / ҚАЗ */}
      <div
        className="fed-menu-item flex p-[4px] bg-surface border border-line rounded-[13px]"
        style={{ marginTop: 10, animationDelay: '.36s' }}
      >
        {[['ru', 'Русский'], ['kz', 'Қазақша']].map(([code, label]) => (
          <button
            key={code}
            onClick={() => { if (lang !== code) toggleLang(); }}
            className="flex-1 h-[42px] border-none rounded-[10px] cursor-pointer font-display font-semibold uppercase transition-colors"
            style={{
              fontSize: 13.5, letterSpacing: '.04em',
              background: lang === code ? 'linear-gradient(120deg,var(--fed-accent-bright),var(--fed-accent-deep))' : 'transparent',
              color: lang === code ? '#fff' : 'var(--fed-fg-muted)',
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
